import styled from 'styled-components'
import {
	BLUE,
	LIGHTGRAY,
	GRAY,
	MEDIUMGRAY,
	PRIMARY_COLOR,
} from '../../../styles/colors.style'
import { confirmGradient } from '../../../styles/reusable.style'
import Browser from '../../../services/Browser'
import { breakpoints } from '../../../constants'

export const StyledCreditCards = styled.section`
	.credit-card-container {
		font-size: 2rem;
		border: solid 1px ${LIGHTGRAY};
		border-radius: 2px;
		padding: 10px;
		display: flex;
		justify-content: space-between;

		.card-icon {
			max-width: 45px;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				max-width: none;
			}
		}

		div {
			display: flex;
			align-items: center;
			padding-right: 10px;
		}
	}

	.number {
		font-size: 16px;
		padding-right: 10px;
		color: ${BLUE};
	}

	.check {
		color: ${PRIMARY_COLOR};
		background: ${Browser.isIE() ? 'white' : confirmGradient()};
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.icons-container {
		display: flex;
		justify-self: flex-end;

		.fa {
			font-size: 20px;

			&-exchange,
			&-trash {
				color: ${GRAY};
			}
		}
	}

	.trash-icon {
		padding-right: 10px;
	}

	.edit-icons {
		color: black;
		cursor: pointer;
	}

	.button-container {
		display: flex;
		justify-content: flex-end;

		button {
			margin-top: 15px;
			padding: 1.5rem;
		}
	}

	.title {
		color: ${MEDIUMGRAY};
		font-weight: 600;
		font-size: 20px;
		text-align: start;
	}

	.no-credit-card-label {
		font-weight: bold;
		margin: 0;
	}
`
